module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/payment/user-charges/user-charges.component.sass
// module id = ./src/app/payment/user-charges/user-charges.component.sass
// module chunks = main